import { Injectable } from '@angular/core';
import { type IReffable } from '@principle-theorem/shared';
import {
  type IRoutable,
  StateBasedNavigationService,
  type IContextualAction,
} from '@principle-theorem/ng-principle-shared';

@Injectable({
  providedIn: 'root',
})
export class LoadMarketingCampaignActionService implements IContextualAction {
  icon = 'open_in_new';
  name = 'View Marketing Campaign';

  constructor(private _stateNav: StateBasedNavigationService) {}

  async do(marketingCampaign: IRoutable | IReffable): Promise<void> {
    const uid: string =
      'uid' in marketingCampaign
        ? marketingCampaign.uid
        : marketingCampaign.ref.id;
    await this._stateNav.organisation(['campaigns', uid]);
  }
}
